import actionsTypes from "../actionsTypes";

export const fetchTestMetadata = id =>{
  return{
    type: actionsTypes.FETCH_TEST_METADATA,
    payload: id
  };
};

export const setTestData = data =>{
  return{
    type: actionsTypes.SET_TEST_DATA,
    payload: data
  };
};

export const setInfoPanelMode = data => {
  return {
    type: actionsTypes.SET_INFO_PANEL_MODE,
    payload: data
  };
};

export const setTumorInfo = data => {
  return {
    type: actionsTypes.SET_TUMOR_INFO,
    payload: data
  };
};

export const setTestSampleType = data => {
  return {
    type: actionsTypes.SET_TEST_SAMPLE_TYPE,
    payload: data
  };
};

export function setLoading(status) {
  return {
    type: actionsTypes.SET_LOADING,
    payload: status
  };
}

export const setInfoPanelIsLoading = data => {
  return {
    type: actionsTypes.SET_INFO_PANEL_IS_LOADING,
    payload: data
  };
};

export const setTestGeneralInfo = data => {
  return {
    type: actionsTypes.SET_TEST_GENERAL_INFO,
    payload: data
  };
};

export const saveTestPhenotype = data => {
  return {
    type: actionsTypes.SAVE_TEST_PHENOTYPE,
    payload: data
  };
};
